import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
`;
export const ActionsContainer = styled.div`
  display: flex;
  margin: 16px 0px;
  gap: 8px;
  flex-direction: column;
`;
export const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: row;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
`;

export const VideoContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const PreviewVideo = styled.video`
  display: ${props => (props.recording || props.videoBlob ? 'none' : 'block')};
`;

export const RecordedVideo = styled.video`
  display: ${props => (props.recording || props.videoBlob ? 'block' : 'none')};
  -webkit-media-controls-panel {
    display: flex !important;
    opacity: 1 !important;
  }
`;

export const MicrophoneContainer = styled.div.attrs(props => ({
  style: {
    visibility: props.videoBlob ? 'hidden' : 'visible'
  }
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 220px;
`;

export const MicrophoneMeter = styled.div`
  width: 10px;
  height: 200px;
  background-color: #ddd;
  position: relative;
  overflow: hidden;
`;

export const MicrophoneLevel = styled.div.attrs(props => ({
  style: {
    height: `${props.micLevel * 100}%`
  }
}))`
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: green;
  transition: height 0.01s;
`;

export const MicrophoneIcon = styled.div`
  margin-top: 5px;
`;

export const STATUS_COLORS = {
  success: {
    background: '#e8f5e8',
    color: '#155724'
  },
  warning: {
    background: '#fff3cd',
    color: '#856404'
  },
  error: {
    background: '#f8d7da',
    color: '#721c24'
  }
};

export const StatusMessage = styled.div`
  text-align: center;
  margin-top: 10px;
  margin-right: 23px;
  padding: 8px;
  border-radius: 4px;
  background-color: ${props =>
    STATUS_COLORS[props.status]?.background || '#fff3cd'};
  color: ${props => STATUS_COLORS[props.status]?.color || '#856404'};
  font-size: 14px;
`;

export const blink = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const RecordingIndicator = styled.div`
  position: absolute;
  animation: ${blink} 1.5s cubic-bezier(0.5, 0, 1, 1) infinite alternate;
`;
